module.exports = __webpack_public_path__ + "static/media/Facebook.4eb6c83d.svg";